import { IStepState } from "./stepper.reducer";

export const actionTypes = {
  SET_STEPPER: "SET_STEPPER",
};

const setStepperAction = (stepperPayload: IStepState) => ({
  type: actionTypes.SET_STEPPER,
  payload: stepperPayload,
});

export default {
  setStepperAction,
};
